export default __webpack_public_path__ + "static/media/Beehaz_11_help_center.7c918f9b.png";